import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ChevronDown, Search } from 'lucide-react';
import { COUNTRIES, Country, flag } from './countries';
type Props = {
  value: string;
  onChange: (digits: string) => void;
  country: Country;
  onCountryChange: (c: Country) => void;
  error?: string;
};
export function PhoneInput({
  value,
  onChange,
  country,
  onCountryChange,
  error
}: Props) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const h = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return COUNTRIES;
    return COUNTRIES.filter(c => c.name.toLowerCase().includes(s) || c.dial.includes(s.replace('+', '')));
  }, [q]);
  return <div ref={ref} className="relative" data-id="element-607" data-mp="2q4wywicc7ovo">
      <div className={`flex items-stretch rounded-xl border bg-white transition-[border-color,box-shadow] duration-150 ease-out focus-within:ring-4 ${error ? 'border-red-600 focus-within:ring-red-100' : 'border-gray-200 focus-within:border-brand focus-within:ring-brand-light'}`} data-id="element-608" data-mp="2q3vcjhpvffyn">
        <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="flex items-center gap-1.5 pl-4 pr-3 text-[16px] sm:text-[18px] text-ink hover:bg-gray-50 rounded-l-xl border-r border-gray-100" aria-label="Cambiar país" data-id="element-609" data-mp="2l6v8tdghupap">
          <span className="text-lg leading-none" data-id="element-610" data-mp="2z64kbztr8v8c">{flag(country.iso)}</span>
          <span data-id="element-611" data-mp="2z3qpns2zll1b">+{country.dial}</span>
          <ChevronDown className="w-4 h-4 text-gray-400" data-id="element-612" data-mp="344ekkouc6m0t" />
        </button>
        <label htmlFor="reg-phone" className="sr-only" data-id="element-613" data-mp="3ruim8qnysbp6">WhatsApp</label>
        <input id="reg-phone" type="tel" inputMode="tel" autoComplete="tel-national" required value={value} onChange={e => onChange(e.target.value.replace(/[^\d\s()-]/g, ''))} placeholder="Tu WhatsApp (para confirmar tu cita)" aria-invalid={!!error} className="flex-1 min-w-0 px-4 py-4 sm:py-[18px] text-[16px] sm:text-[18px] text-ink outline-none rounded-r-xl placeholder:text-gray-400" data-id="element-614" data-mp="3rt7i2pqlx1xj" />
      </div>
      {open && <div className="absolute z-30 mt-2 w-full max-w-sm bg-white border border-gray-100 rounded-xl shadow-[0_20px_40px_-16px_rgba(11,13,18,0.25)]" data-id="element-615" data-mp="3nid338fmt4a4">
          <div className="flex items-center gap-2 px-3 py-2.5 border-b border-gray-100" data-id="element-616" data-mp="3iq2365kw5ihk">
            <Search className="w-4 h-4 text-gray-400" data-id="element-617" data-mp="3dtbonmoqiuy9" />
            <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Buscar país" className="flex-1 text-sm outline-none" data-id="element-618" data-mp="38tgu995r3n8g" />
          </div>
          <ul className="max-h-60 overflow-auto py-1" data-id="element-619" data-mp="34r2eixxdp3le">
            {list.map(c => <li key={c.iso} data-id="element-620" data-mp="2ztans78gznis">
                <button type="button" onClick={() => {
            onCountryChange(c);
            setOpen(false);
            setQ('');
          }} className={`w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-brand-light ${c.iso === country.iso ? 'bg-brand-light' : ''}`} data-id="element-621" data-mp="2zv4y6rm47x8m">
                  <span className="text-lg leading-none" data-id="element-622" data-mp="1ochhzp8zzl23">{flag(c.iso)}</span>
                  <span className="flex-1 text-ink" data-id="element-623" data-mp="1tb15hu38p4wk">{c.name}</span>
                  <span className="text-gray-500" data-id="element-624" data-mp="1t8evlnsvmdb6">+{c.dial}</span>
                </button>
              </li>)}
          </ul>
        </div>}
      {error && <p className="mt-1.5 text-sm font-medium text-red-600" data-id="element-625" data-mp="10mn7hec5i8l0">{error}</p>}
    </div>;
}